import {biscReturnCode, IsabelErrors} from "./return-codes";

export var defaultTimeout = 300000;
export var twentyFourDays = 2073600000;

export function timedPromise(ms, promise) {
    // Create a promise that rejects in <ms> milliseconds
    let timeout = new Promise((resolve, reject) => {
      let id = setTimeout(() => {
        clearTimeout(id);
        reject(new Error(biscReturnCode.TimeoutError));
      }, ms)
    });
  
    // Returns a race between our timeout and the passed in promise
    return Promise.race([
      promise,
      timeout
    ]);
  }

export function rc_to_errorcode(rc) {
    switch(rc) {
      case IsabelErrors.ISABEL_CSPX_OK:
        return IsabelErrors.ISABEL_CSPX_OK;
        
      case IsabelErrors.PP_EXT_BAD_BRANDING_SIGNATURE:
        return biscReturnCode.BadBrandingSignature;
        
      case IsabelErrors.ISABEL_CSPX_ISABEL_CARD_NOT_FOUND:
      case IsabelErrors.ISABEL_P11_GET_TOKENINFO_ERROR:
        return biscReturnCode.InsertCard;

      case IsabelErrors.PP_EXT_WRONG_CARD:
        return biscReturnCode.WrongCard;

      case IsabelErrors.PP_EXT_RED_PIN:
        return biscReturnCode.RedPin;
      
      case IsabelErrors.PP_EXT_NO_CARD_READER:
      case IsabelErrors.ISABEL_P11_GET_NO_SLOTS_FOUND:
      case IsabelErrors.ISABEL_P11_INITIALIZATION_ERROR:
        return biscReturnCode.NoCardReader;

      case IsabelErrors.ISABEL_CSPX_CERTIFICATE_NOT_FOUND:
        return biscReturnCode.BiscCertNotFound;

      case IsabelErrors.PP_EXT_WRONG_CA:
        return biscReturnCode.WrongCA;

      case IsabelErrors.PP_EXT_RED_PIN_X_CA:
        return biscReturnCode.RedPinX;

      case IsabelErrors.PP_EXT_WRONG_TIME:
        return biscReturnCode.WrongTime;

      case IsabelErrors.ISABEL_CSPX_SIGNING_BUSY:
        return biscReturnCode.ServiceBusy;

      case IsabelErrors.PP_EXT_WRONG_RECIPIENT:
        return biscReturnCode.WrongRecipient;

      case IsabelErrors.PP_EXT_COMMUNICATION_ERROR:
        return biscReturnCode.CommErr;

      case IsabelErrors.ISABEL_NO_EID_CARD_FOUND:
        return biscReturnCode.NoEidCard;

      case IsabelErrors.ISABEL_UNKOWN_CERTIFICATE_ID:
        return biscReturnCode.UnknownEidCert;

      case IsabelErrors.ISABEL_CSPX_CARD_SWITCHED:
        return biscReturnCode.SwitchedCard;
        
      case IsabelErrors.ISABEL_CSPX_CARD_NOT_ACTIVE:
      case IsabelErrors.PP_EXT_INACTIVE_CARD:
        return biscReturnCode.InactiveCard;

      case IsabelErrors.ISABEL_CSPX_CANCEL:
        return biscReturnCode.UserCancelled;

      case IsabelErrors.ISABEL_CSPX_FORCE_PINPAD_ERROR:
      case IsabelErrors.PP_EXT_NO_PINPAD_READER:
        return biscReturnCode.NoPinpad;

      case IsabelErrors.ISABEL_CSPX_PIN_LOCKED:
      case IsabelErrors.PP_EXT_BLOCKED_PIN:
        return biscReturnCode.BlockedPin;

      case IsabelErrors.ISABEL_CSPX_EPAYMENT_PKIUID_MISMATCH:
      case IsabelErrors.PP_EXT_WRONG_USER:
        return biscReturnCode.WrongUser;  

      case IsabelErrors.ISABEL_CSPX_TIMEOUT:
        return biscReturnCode.TimeoutError; 

      case IsabelErrors.PP_EXT_PINPAD_ERROR:
        return biscReturnCode.PINpadErr;  

      case IsabelErrors.PP_EXT_SMARTCARD_ERROR:
        return biscReturnCode.SCardErr;  

      case IsabelErrors.PP_EXT_FAILED_GET_CERT:
        return biscReturnCode.FailedGetCert;  

      case IsabelErrors.PP_EXT_CONFIG_ERROR:
        return biscReturnCode.ConfigError;      

      case IsabelErrors.PP_EXT_NO_ISABEL_READER:
        return biscReturnCode.NoIsabelReader;    

      case IsabelErrors.PP_EXT_ORANGE_PIN:
        return biscReturnCode.OrangePin;

      default:
        return biscReturnCode.InternalError;
    }
  }

  